import { PatchAssociateMemberFilePayload } from '@troyai/patients/data-access';
import { CreateOrEditClinicalObservationPayload } from '../models/new-clinical-observation-payload.interface';

export class GetPatientClinicalObservations {
  static readonly type = '[Clinical Observations] Get patient clinical observations';
  constructor(public payload: { globalId?: number }) {}
}

export class GetPatientClinicalObservationGroups {
  static readonly type = '[Clinical Observations] Get patient clinical observation groups';
  constructor(public payload: { globalId?: number }) {}
}

export class GetSinglePatientClinicalObservation {
  static readonly type = '[Clinical Observations] Get single patient clinical observation';
  constructor(
    public payload: {
      memberGlobalId: number;
      clinicalObservationId: number;
    }
  ) {}
}

export class AddNewClinicalObservation {
  static readonly type = '[Clinical Observations] Add new clinical observation';
  constructor(
    public memberGlobalId: number,
    public payload: CreateOrEditClinicalObservationPayload
  ) {}
}

export class EditClinicalObservation {
  static readonly type = '[Clinical Observations] Edit selected clinical observation';
  constructor(
    public memberGlobalId: number,
    public payload: CreateOrEditClinicalObservationPayload
  ) {}
}

export class EmptySelectedClinicalObservation {
  static readonly type = '[Clinical Observations] Empty selected clinical observation';
}

export class SearchStandardMedicalCode {
  static readonly type = '[Clinical Observations] Search standard medical code';
  constructor(public code: string) {}
}

export class AssociateMemberFilesToClinicalObservation {
  static readonly type = '[Clinical Observations] Associate member files to clinical observation';
  constructor(
    public payload: {
      memberGlobalId: number;
      fileIds: number[];
      data: PatchAssociateMemberFilePayload;
    }
  ) {}
}

export class ToggleClinicalObservationGroupPinned {
  static readonly type = '[Clinical Observations] Toggle clinical observation group pinned';
  constructor(public payload: { groupName: string; isPinned: boolean }) {}
}

export class ToggleClinicalObservationGroupExpanded {
  static readonly type = '[Clinical Observations] Toggle clinical observation group expanded';
  constructor(public payload: { groupName: string; isExpanded: boolean }) {}
}
